import { render, staticRenderFns } from "./Tag_list.vue?vue&type=template&id=0aa593cc&scoped=true"
import script from "./Tag_list.vue?vue&type=script&lang=js"
export * from "./Tag_list.vue?vue&type=script&lang=js"
import style0 from "./Tag_list.vue?vue&type=style&index=0&id=0aa593cc&prod&scoped=true&lang=css"
import style1 from "./Tag_list.vue?vue&type=style&index=1&id=0aa593cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa593cc",
  null
  
)

export default component.exports